import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import uuid from "uuid/v4";

@Injectable()
export class UUIDInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const dupReq = req.clone({
      setHeaders: { 'Request-Id': uuid() }
    });
    return next.handle(dupReq);
  }
}
